import { create } from "zustand/react"
import { CoinInterface } from "@/app/interfaces/coin.interface"

const useSelectedCoinStore = create((set: any) => ({
  selectedCoin: null as CoinInterface | null,
  setSelectedCoin: (coin: any) => set((state: any) => ({ selectedCoin: coin })),
}))
export default useSelectedCoinStore